"use client";

type ReservationBookingSidebarSkeletonProps = {
  className?: string;
  /** Modal içi daha kompakt yerleşim */
  compact?: boolean;
};

/** Lazy `/pricing` yüklenirken rezervasyon sidebar placeholder */
export default function ReservationBookingSidebarSkeleton({
  className = "",
  compact = false,
}: ReservationBookingSidebarSkeletonProps) {
  return (
    <div
      className={`animate-pulse ${compact ? "space-y-3" : "space-y-4"} ${className}`}
      aria-busy="true"
      aria-live="polite"
    >
      <div className={`bg-gray-200 rounded-lg ${compact ? "h-9" : "h-10"}`} />
      <div className={`bg-gray-200 rounded-lg ${compact ? "h-9" : "h-10"}`} />
      <div className={`bg-gray-100 rounded-lg border border-gray-200 ${compact ? "h-20" : "h-24"}`} />
      <div className="flex gap-2">
        <div className="h-10 bg-gray-200 rounded-lg flex-1" />
        <div className="h-10 bg-gray-200 rounded-lg flex-1" />
      </div>
      <div className={`bg-gray-200 rounded-lg w-full ${compact ? "h-11" : "h-12"}`} />
    </div>
  );
}
